import { ArrowDownOutlined, ArrowUpOutlined, MinusOutlined } from '@ant-design/icons';

import { useT } from '../../../i18n';
import { cn } from '../../../lib/cn';
import { MAU_XU_HUONG } from '../constants';
import type { Trend } from '../types';

/**
 * Mũi tên xu hướng — **màu lấy từ `trend`, không từ dấu của `delta`**: `-4,1%` ở dòng Công nợ là tin tốt,
 * mũi tên xuống mà người nhập vẫn chọn `up`. Tên xu hướng đọc cho trình đọc màn hình; màu chỉ là tín hiệu.
 */
export function XuHuong({ trend, delta }: { trend: Trend; delta?: string }) {
  const { t } = useT();
  const Icon = trend === 'up' ? ArrowUpOutlined : trend === 'down' ? ArrowDownOutlined : MinusOutlined;
  return (
    <span className={cn('inline-flex items-center gap-1 text-xs font-medium', MAU_XU_HUONG[trend])}>
      <Icon aria-hidden />
      <span className="sr-only">{t(`baoCaoDoanhNghiep.xuHuongGiaTri.${trend}`)}</span>
      {delta ? <span className="tabular-nums">{delta}</span> : null}
    </span>
  );
}
